import styled from "styled-components";

export const StyledUserScheduleList = styled.div`
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
  padding: 2.4rem 1.6rem;
`;
export const StyledUserScheduleListTitle = styled.div`
  font-size: 1.6rem;
`;
